import React from "react";

import { MailIcon } from "@heroicons/react/outline";

export default function ModalHelpEmail() {
  return (
    <div className="w-full h-56 space-y-5 p-4">
      <div className="text-center justify-start text-zinc-500 text-2xl font-medium">
        Para entrar em contato com o SAC
      </div>
      <MailIcon className="w-5 h-5 text-blue-500 mx-auto" />
      <div className="w-full space-y-2 text-center">
        <div className="text-center justify-start text-zinc-500 text-lg font-normal">
          enviar e-mail para
        </div>
        <a
          href="mailto:sac@thopenergy.com.br"
          className="text-[#4169e1] w-full text-center hover:opacity-55 transition-all duration-150"
        >
          sac@thopenergy.com.br
        </a>
      </div>
    </div>
  );
}
